module.exports = __webpack_public_path__ + "img/zambia.927f193f.svg";